import { createAsyncThunk } from "@reduxjs/toolkit"
import { batch } from "react-redux"

import { AppDispatch } from "@/App"
import { Site } from "@/sites"
import { getClients } from "@/store/clients"
import { getDrivers } from "@/store/drivers"
import { getNotifications } from "@/store/notifications"
import { getOrders } from "@/store/orders"
// import { getTeamStats } from "@/store/teamsStats"
import { RootState } from "@/types"

export function getWebSocketURI({ wsHost, protocol, wsPort }: Site) {
  const wsProtocol = protocol === "https" ? "wss" : "ws"

  return `${wsProtocol}://${wsHost}${wsPort ? `:${wsPort}` : ""}/cable`
}

export function subscribe(channel: string, teamUuid: string) {
  return JSON.stringify({
    command: "subscribe",
    identifier: JSON.stringify({
      channel,
      uuid: teamUuid,
    }),
  })
}

export function unsubscribe(channel: string, teamUuid: string) {
  return JSON.stringify({
    command: "unsubscribe",
    identifier: JSON.stringify({
      channel,
      uuid: teamUuid,
    }),
  })
}

export const requestDataRefresh = createAsyncThunk<void, void, { dispatch: AppDispatch; state: RootState }>(
  "refreshData",
  (_, { getState, dispatch }) => {
    const {
      teams: { current: currentTeam, currentMulti },
      global: { date },
      user: { isAuthenticated },
    } = getState()

    if (!isAuthenticated || !date) return

    batch(() => {
      if (currentTeam) {
        dispatch(getOrders({ teamId: currentTeam.id, date }))
        dispatch(getDrivers({ teamIds: [currentTeam.id], date }))
        dispatch(getClients([currentTeam.id]))
        dispatch(getNotifications([currentTeam.uuid]))
        // dispatch(getTeamStats([currentTeam.id]))
      }

      if (currentMulti) {
        dispatch(getNotifications(currentMulti.map((team) => team.uuid)))
      }
    })
  }
)
